import React, { useState } from 'react'
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import MissionModelingService from '../MissionModelingService';
import Dialog from '../../CommonComponents/Dialog';
import { useParams } from "react-router-dom";

interface AoiSpaceObjectProps {
    AoiObject: any;
    setVisualisationProperties: (name:string, id: string) => void;
    openModal: (selectedItem: any) => void;
    props : any;
}
const AoiSpaceObjectContainer: React.FC<AoiSpaceObjectProps> = ({AoiObject, setVisualisationProperties, openModal, props}) => {
    const params = useParams()
  const {
    mission_name,
    mission_id
  } = params;

    const [expanded, setExpanded] = useState<any>([])
    const [openDeleteModal,setOpenDeleteModal] = useState(false)
    const [aoiDeleteId, setAoiDeleteId] = useState()

    const toggleExpanded = (name: string) => {
        if (expanded.includes(name)) {
            setExpanded(expanded.filter((item: string) => item !== name));
        } else {
            setExpanded([...expanded, name]);
        }
    }
    return (
        <>
      <div className={`details ${expanded?.includes(AoiObject?.['id']) ? 'expanded' : ''}`}>
        <div className='summary'>
            <div className='d-flex align-items-center gap-3'>
                <button className={`triangle__toggle__btn ${expanded?.includes(AoiObject?.['id']) ? 'expanded' : ''}`} onClick={(e) => {
                    e.stopPropagation()
                    toggleExpanded(AoiObject?.['id'])
                }}/>
                <button className={`summary__object__name ${expanded?.includes(AoiObject?.['id']) ? 'active' : ''}`} 
                onClick={(e)=>{
                    e.stopPropagation()
                    setVisualisationProperties(AoiObject?.['name'], AoiObject?.['aoiId'])
                }}>
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M18.25 2.74291C18.2481 2.09462 17.9938 1.47253 17.5412 1.0084C17.0886 0.544276 16.473 0.274553 15.825 0.256355C15.177 0.238158 14.5473 0.472915 14.0693 0.91091C13.5913 1.34891 13.3026 1.95574 13.2643 2.60291L5.49102 4.15731C5.30927 3.77957 5.03524 3.45373 4.69425 3.20992C4.35325 2.96611 3.9563 2.81219 3.54008 2.76239C3.12385 2.71259 2.70179 2.76851 2.3129 2.92499C1.92401 3.08146 1.58084 3.33345 1.3151 3.65765C1.04937 3.98185 0.869645 4.36781 0.792544 4.77984C0.715444 5.19188 0.743454 5.61671 0.873986 6.01506C1.00452 6.41341 1.23336 6.77243 1.53936 7.05893C1.84536 7.34544 2.21865 7.55018 2.62472 7.65424V12.8318C2.19845 12.9413 1.80872 13.1615 1.49509 13.4702C1.18145 13.779 0.955078 14.1652 0.838941 14.5896C0.722804 15.0141 0.721038 15.4618 0.833823 15.8872C0.946607 16.3126 1.16993 16.7005 1.48112 17.0117C1.7923 17.3229 2.18028 17.5462 2.60567 17.659C3.03106 17.7718 3.47872 17.77 3.90321 17.6539C4.32769 17.5378 4.7139 17.3114 5.02262 16.9978C5.33134 16.6841 5.5516 16.2944 5.66102 15.8681H10.8386C10.9425 16.2745 11.1472 16.648 11.4337 16.9543C11.7203 17.2606 12.0794 17.4897 12.4779 17.6204C12.8764 17.7511 13.3015 17.7792 13.7137 17.7021C14.126 17.625 14.5122 17.4452 14.8366 17.1794C15.1609 16.9135 15.413 16.5701 15.5695 16.181C15.726 15.7919 15.7819 15.3696 15.732 14.9532C15.682 14.5368 15.5279 14.1396 15.2838 13.7986C15.0397 13.4575 14.7136 13.1835 14.3356 13.0018L15.89 5.22858C16.5263 5.1938 17.1252 4.91697 17.564 4.45481C18.0028 3.99266 18.2482 3.38019 18.25 2.74291ZM15.75 1.49289C15.9972 1.49289 16.2389 1.56621 16.4444 1.70356C16.65 1.84091 16.8102 2.03614 16.9048 2.26455C16.9994 2.49296 17.0242 2.7443 16.976 2.98678C16.9277 3.22926 16.8087 3.45199 16.6339 3.62681C16.459 3.80163 16.2363 3.92068 15.9938 3.96892C15.7513 4.01715 15.5 3.99239 15.2716 3.89778C15.0432 3.80317 14.848 3.64295 14.7106 3.43739C14.5732 3.23182 14.4999 2.99014 14.4999 2.74291C14.5003 2.41149 14.6321 2.09373 14.8664 1.85938C15.1008 1.62503 15.4185 1.49322 15.75 1.49289ZM1.9997 5.24296C1.9997 4.99572 2.07302 4.75405 2.21037 4.54848C2.34772 4.34292 2.54295 4.1827 2.77136 4.08809C2.99978 3.99348 3.25111 3.96872 3.49359 4.01695C3.73607 4.06519 3.95881 4.18424 4.13363 4.35906C4.30845 4.53388 4.4275 4.75661 4.47573 4.99909C4.52396 5.24157 4.49921 5.49291 4.4046 5.72132C4.30999 5.94973 4.14977 6.14496 3.9442 6.28231C3.73864 6.41966 3.49696 6.49298 3.24973 6.49298C2.9183 6.49265 2.60055 6.36084 2.36619 6.12649C2.13184 5.89214 2.00003 5.57438 1.9997 5.24296ZM3.24973 16.4931C3.0025 16.4931 2.76082 16.4198 2.55525 16.2825C2.34969 16.1451 2.18947 15.9499 2.09486 15.7215C2.00024 15.4931 1.97549 15.2417 2.02372 14.9993C2.07195 14.7568 2.19101 14.534 2.36583 14.3592C2.54065 14.1844 2.76338 14.0654 3.00586 14.0171C3.24834 13.9689 3.49968 13.9936 3.72809 14.0883C3.9565 14.1829 4.15173 14.3431 4.28908 14.5486C4.42644 14.7542 4.49975 14.9959 4.49975 15.2431C4.49942 15.5745 4.36761 15.8923 4.13326 16.1267C3.89891 16.361 3.58115 16.4928 3.24973 16.4931ZM10.8386 14.6181H5.66102C5.54906 14.1884 5.32451 13.7963 5.01051 13.4823C4.69652 13.1683 4.30445 12.9438 3.87474 12.8318V7.65424C4.3854 7.52142 4.84072 7.22992 5.1751 6.82174C5.50949 6.41356 5.70567 5.90978 5.7354 5.38296L13.5087 3.82856C13.7536 4.33245 14.1605 4.7396 14.6643 4.98483L13.1099 12.7575C12.5831 12.7872 12.0793 12.9834 11.6711 13.3177C11.2629 13.6521 10.9714 14.1074 10.8386 14.6181ZM13.2499 16.4931C13.0027 16.4931 12.761 16.4198 12.5554 16.2825C12.3499 16.1451 12.1896 15.9499 12.095 15.7215C12.0004 15.4931 11.9757 15.2417 12.0239 14.9993C12.0721 14.7568 12.1912 14.534 12.366 14.3592C12.5408 14.1844 12.7636 14.0654 13.006 14.0171C13.2485 13.9689 13.4999 13.9936 13.7283 14.0883C13.9567 14.1829 14.1519 14.3431 14.2893 14.5486C14.4266 14.7542 14.4999 14.9959 14.4999 15.2431C14.4996 15.5745 14.3678 15.8923 14.1334 16.1267C13.8991 16.361 13.5813 16.4928 13.2499 16.4931Z" fill="#F0F0F0"/>
                    </svg>
                    {AoiObject?.['name']}
                    </button>
            </div>
            
            <ButtonGroup size="sm" className="space__object__action_btns" >
                <div className="btn-list more-button">
                    <Dropdown drop="down-centered">
                        <Dropdown.Toggle size="sm" variant="transparent">
                            <i className="fe fe-more-vertical fs-20 opacity-70"/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {/* <Dropdown.Item
                                eventKey="0"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openModal(AoiObject)
                                }}
                            >
                                Edit
                            </Dropdown.Item> */}
                            <Dropdown.Item
                                eventKey="1"
                                onClick={(e) => {
                                    setAoiDeleteId(AoiObject?.['aoiId'])
                                    setOpenDeleteModal(true)
                                    e.stopPropagation();
                                }}
                            >
                                Delete
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </ButtonGroup>
        </div>
        {expanded?.includes(AoiObject?.['id']) &&
            <div className='object__details__body__section'>
                <button className='bg-transparent py-2 w-90 px-0'>Configuration</button>
            </div>
        }
      </div>
      <Dialog
                onClick={(event) => {
                    if (event) {
                        MissionModelingService.deleteAreaOfInterest(aoiDeleteId, mission_id).then((res)=>{
                            props.setSidebarProps({
                                sidebarComponent: props.sidebarComponent,
                                isSidebarVisible: props.isSidebarVisible,
                                isComponentUpdated: !props.isComponentUpdated,
                              });
                        }).then((err) => {
                            console.log(err)
                        })
                    }
                    setOpenDeleteModal(false)
                }}
                openModel={openDeleteModal} comment={`Do you want to delete ${AoiObject?.['name']} Area Of Interest ?`}
            />
      </>
    );
};

export default AoiSpaceObjectContainer
